import React from 'react';

import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

interface Props {
  url?: string;
}

const SeeAllCard = ({ url }: Props) => {
  if (!url) return null;

  return (
    <S.SeeAllContainer href={url}>
      <div>
        <p>{I18n.t('view-product-screen.see-all-card.message')}</p>
        <Icon name="arrow-foreward" size={24} />
      </div>
      <button disabled>{I18n.t('view-product-screen.see-all-card.button')}</button>
    </S.SeeAllContainer>
  );
};

export default SeeAllCard;
